










































































































































import { mixins } from "vue-class-component";
import { Component, Prop } from "vue-property-decorator";
import ReportDocumentSignRequestStepperChoice from "./ReportDocumentSignRequestStepperChoice.vue";
import ReportDocumentSignRequestStepperFileSelection from "./ReportDocumentSignRequestStepperFileSelection.vue";
import ReportDocumentSignRequestStepperInputs from "./ReportDocumentSignRequestStepperInputs.vue";
import ReportDocumentSignRequestStepperMixin from "./ReportDocumentSignRequestStepperMixin.vue";
import ReportDocumentSignRequestStepperUpload from "./ReportDocumentSignRequestStepperUpload.vue";
import ReportDocumentSignRequestStepperSuccess from "./ReportDocumentSignRequestStepperSuccess.vue";
import ReportDocumentSignRequestStepperForm from "./ReportDocumentSignRequestStepperForm.vue";
import { SignDigitalSignatureRequestViewModelGen, SignDocumentViewModelGen } from "@/services/sign/v1/data-contracts";
import { ReportEntity } from "@/models/reportEntity";
import ReportDocumentSignRequestStepperMailSuccess from "./ReportDocumentSignRequestStepperMailSuccess.vue";
import ReportDocumentSignRequestStepperSendMail from "./ReportDocumentSignRequestStepperSendMail.vue";
import ReportDocumentSignRequestStepperDa from "./ReportDocumentSignRequestStepperDa.vue";

export enum SignRequestStepperPageEnum {
  CHOICE = "choice",
  UPLOAD = "upload",
  SIGNATURE_SELECTION = "signatureSelection",
  FILE_SELECTION = "fileSelection",
  INPUTS = "inputs",
  SUCCESS = "success",
  MAIL = "mail",
  MAIL_SUCCESS = "mailSuccess",
  DA_IMPORT = "daImport"
}
export interface IStepper {
  next: (() => Promise<void>) | (() => void);
  previous: (() => Promise<void>) | (() => void);
}

@Component({
  components: {
    ReportDocumentSignRequestStepperChoice,
    ReportDocumentSignRequestStepperUpload,
    ReportDocumentSignRequestStepperFileSelection,
    ReportDocumentSignRequestStepperForm,
    ReportDocumentSignRequestStepperInputs,
    ReportDocumentSignRequestStepperSuccess,
    ReportDocumentSignRequestStepperSendMail,
    ReportDocumentSignRequestStepperMailSuccess,
    ReportDocumentSignRequestStepperDa
  }
})
export default class ReportDocumentSignRequestSteps extends mixins(ReportDocumentSignRequestStepperMixin) {
  @Prop({ default: false })
  fullscreen?: boolean;
  @Prop()
  private report?: ReportEntity;

  signDocument: SignDocumentViewModelGen | null = null;
  reportContext: ReportEntity | null = null;
  signRequest: SignDigitalSignatureRequestViewModelGen | null = null;

  url = "";

  get SignRequestStepperPageEnum() {
    return SignRequestStepperPageEnum;
  }

  setReport(r: ReportEntity | null) {
    this.$log.debug(r);
    this.reportContext = r;
    this.$log.debug(this.reportContext);
  }

  setSignDocument(v: SignDocumentViewModelGen) {
    this.signDocument = v;
  }

  setSignRequest(signRequest: SignDigitalSignatureRequestViewModelGen) {
    this.signRequest = signRequest;
  }

  setUrl(url: string) {
    this.url = url;
  }

  previous() {
    (this.$refs[this.currentStep] as any).previous();
    if (this.currentStep === SignRequestStepperPageEnum.CHOICE) {
      this.reset();
    }
  }

  async next() {
    await (this.$refs[this.currentStep] as any).next();
    if (this.currentStep === SignRequestStepperPageEnum.CHOICE) {
      this.reset();
    }
  }

  reset() {
    this.signDocument = null;
    this.signRequest = null;
    this.url = "";
  }

  close() {
    this.currentStep = SignRequestStepperPageEnum.CHOICE;
    this.$emit("close");
    this.reset();
  }

  /**
   * When the signature request has been saved
   *
   * - drop the report context
   */
  save() {
    this.setReport(null);
    this.$emit("save");
  }

  mounted() {
    if (this.report) {
      this.reportContext = this.report;
    }
  }
}
